/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "ขวาไปซ้าย",
		"timeZoneID": "เขตเวลา",
		"skin": "สไตล์",
		"metricsFileImportTask": "สร้างอิมพอร์ตใหม่จากไฟล์",
		"displayMode": "มุมมองดีฟอลต์",
		"credentialRenewed": "หนังสือรับรองของคุณได้รับการต่ออายุด้วย ID ผู้ใช้และรหัสผ่านปัจจุบันของคุณ",
		"productLocale": "ภาษของผลิตภัณฑ์",
		"toggleDisabled": "ปิด",
		"credentialChange": "ต่ออายุ",
		"log_level_Debug": "ดีบัก",
		"confirmNewPassword": "ยืนยันรหัสผ่านใหม่",
		"unsavedViewMsg2": "การเปลี่ยนแปลงของคุณจะหายไปหากคุณไม่บันทึกไว้ก่อน",
		"supportPortalErrorMessage": "ลองอีกครั้ง  หากยังมีปัญหาอยู่ โปรดติดต่อผู้ดูแลระบบของคุณ",
		"legalText": "งานอันมีลิขสิทธิ์ - ทรัพย์สินของ IBM Corp. © ลิขสิทธิ์ IBM Corporation และอื่น ๆ 2005, %{year} IBM, ตราสัญลักษณ์ IBM, ibm.com และ Cognos เป็นเครื่องหมายการค้าหรือเครื่องหมายการค้าจดทะเบียนของ International Business Machines Corp. ซึ่งจดทะเบียนในเขตอำนาจศาลหลายแห่งทั่วโลก รายการปัจจุบันของเครื่องหมายการค้า IBM มีอยู่บนเว็บที่ www.ibm.com/legal/copytrade.shtml โปรแกรมนี้ได้รับการจดสิทธิ์อนุญาตใช้งานภายใต้เงื่อนไขของข้อตกลงสิทธิ์อนุญาตที่มาพร้อมกับโปรแกรม ข้อตกลงเกี่ยวกับไลเซนส์อาจวางอยู่ในโฟลเดอร์ไดเร็กทอรี Program หรือไลบรารีที่ระบุว่าเป็น \"License\" หรือ \"Non_IBM_License\" หากมีอยู่ หรือจัดเตรียมไว้ในรูปของข้อตกลงเกี่ยวกับไลเซนส์ที่สามารถพิมพ์ได้ โปรดอ่านข้อตกลงอย่างรอบคอบก่อนใช้โปรแกรม โดยการใช้โปรแกรม คุณตกลงที่จะทำตามเงื่อนไขเหล่านี้",
		"groupsAndRoles": "กลุ่มและบทบาท",
		"metricsMaintenanceTask": "สร้างการดูแลรักษา",
		"email": "อีเมล",
		"contextual": "เชิงบริบท",
		"resetHome": "รีเซ็ตเป็นดีฟอลต์",
		"ltr": "ซ้ายไปขวา",
		"credentials": "หนังสือรับรอง",
		"logging_congfig_title": "การบันทึก",
		"changePasswordTitle": "เปลี่ยนรหัสผ่านของฉัน",
		"format": "รูปแบบรายงาน",
		"showUnread": "แสดงที่ไม่ได้อ่าน",
		"AILearning_active": "การเรียนรู้ของ AI เปิดอยู่:",
		"docsErrorMessage": "ลองอีกครั้ง  หากยังมีปัญหาอยู่ โปรดติดต่อผู้ดูแลระบบของคุณ",
		"toggleEnabled": "เปิด",
		"homeSetError": "เกิดข้อผิดพลาดในการตั้งค่าโฮมเพจดีฟอลต์ ให้ลองปิดและเปิดมุมมองนี้ใหม่",
		"passwordChange": "เปลี่ยนรหัสผ่านของคุณ",
		"profile": "โปรไฟล์",
		"pdfRestricted": "PDF (จำกัด)",
		"drillThrough": "นิยามการเจาะลึก",
		"homeSet": "โฮมของคุณถูกตั้งค่าเป็นผลสำเร็จแล้ว",
		"regionalOptions": "อ็อพชันตามภูมิภาค",
		"myPreferences": "การกำหนดค่าตามความชอบของฉัน",
		"defaultHome": "ดีฟอลต์",
		"version": "เวอร์ชัน",
		"controller": "คอนโทรลเลอร์",
		"manage": "จัดการ",
		"biDirectionalFeaturesEnabled": "ส่วนสนับสนุนภาษาแบบสองทิศทาง",
		"newFeaturesErrorTitle": "ลิงก์ไปยัง คุณลักษณะใหม่ ใช้ไม่ได้",
		"passwordMatch": "รหัสผ่านตรงกัน",
		"updateProfileAndsettings": "อัพเดตโปรไฟล์และการตั้งค่า",
		"dashboardConsole": "เวิร์กสเปซ",
		"legacyAppsSlideoutLabel": "แอ็พพลิเคชันที่สืบทอดซึ่งพร้อมใช้งาน",
		"logging_config_description": "การล็อกใช้สำหรับการแก้ไขปัญหา โปรดปรึกษาผู้ดูแลระบบของคุณสำหรับคำแนะนำเกี่ยวกับการตั้งค่า",
		"confirmDeletion": "ยืนยันการลบ",
		"signInButtonText": "ล็อกอิน",
		"dataSourceCredentials": "หนังสือรับรองเซิร์ฟเวอร์ข้อมูล",
		"AILearningConfigurationSlideoutAllyLabel": "การกำหนดคอนฟิกการเรียนรู้ของ AI",
		"loadingSettings": "กำลังโหลดการตั้งค่า",
		"spreadsheetMLRestricted": "Excel (จำกัด)",
		"manageAILearning": "การเรียนรู้ของ AI",
		"xlsxDataRestricted": "ข้อมูล Excel (จำกัด)",
		"advanced": "อ็อพชันขั้นสูง",
		"ok": "ตกลง",
		"changeEmail": "ค่าเปลี่ยนแปลง",
		"showHints": "แสดงคำใบ้",
		"general": "ทั่วไป",
		"xlsxData": "ข้อมูล Excel",
		"newPassword": "รหัสผ่านใหม่",
		"hideAll": "ซ่อนทั้งหมด",
		"confirmPassword": "ยืนยันรหัสผ่าน",
		"AILearning_config_description": "ปรับปรุงข้อเสนอแนะในผลิตภัณฑ์โดยอนุญาตให้ Cognos Analytics เรียนรู้เกี่ยวกับการใช้งานของคุณ",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "ลิงก์ไปยัง พอร์ทัลที่สนับสนุน ใช้ไม่ได้",
		"log_level_Warn": "คำเตือน",
		"contentSettings": "เนื้อหาเนื้อหา",
		"setHomeButton": "ตั้งค่า",
		"myCapabilities": "ความสามารถของฉัน",
		"homePage": "โฮมเพจ",
		"helpErrorMessage": "ลองอีกครั้ง  หากยังมีปัญหาอยู่ โปรดติดต่อผู้ดูแลระบบของคุณ",
		"loadingProfile": "กำลังโหลดโปรไฟล์",
		"portal": "พอร์ทัล",
		"metricsPackage": "แพ็กเกจใหม่",
		"myCredentials": "หนังสือรับรองของฉัน",
		"myApiKeys": "คีย์ API ของฉัน",
		"credentialCreate": "สร้าง",
		"eventStudio": "สตูดิโอเหตุการณ์",
		"updatePWUnknownError": "ไม่สามารถอัพเดตรหัสผ่าน",
		"showHiddenObjects": "แสดงรายการที่ซ่อน",
		"csv": "CSV",
		"docsErrorTitle": "ลิงก์ไปยังเอกสารคู่มือใช้ไม่ได้",
		"log_level_Error": "ข้อผิดพลาด",
		"wrongPassword": "ไม่สามารถพิสูจน์ตัวตนได้",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "แจ้งให้ทราบ",
		"welcomeBanner": "แบนเนอร์ยินดีต้อนรับ",
		"helpErrorTitle": "ลิงก์ไปยัง วิธีใช้ ใช้ไม่ได้",
		"contentLocale": "ภาษาของเนื้อหา",
		"pdf": "PDF",
		"oldPassword": "รหัสผ่านเก่า",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "คุณลักษณะการเข้าถึง",
		"manageLogging": "การบันทึก",
		"loggingConfigurationSlideoutA11yLabel": "คอนฟิกูเรชันการล็อก",
		"communityErrorTitle": "ลิงก์ัไปยัง ชุมชน ใช้ไม่ได้",
		"companionApps": "แอ็พพลิเคชัน Companion",
		"setHomeLabel": "ตั้งค่าโฮมเป็น (มุมมองปัจจุบัน)",
		"metricsExportTask": "เอ็กซ์พอร์ตใหม่",
		"csvRestricted": "CSV (จำกัด)",
		"newFeaturesErrorMessage": "ลองอีกครั้ง  หากยังมีปัญหาอยู่ โปรดติดต่อผู้ดูแลระบบของคุณ",
		"contributor": "ผู้มีส่วนร่วม",
		"showAll": "แสดงทั้งหมด",
		"logging_active": "การล็อกเปิดอยู่:",
		"html": "HTML",
		"profileAndSettings": "โปรไฟล์และการตั้งค่า",
		"baseTextDirection": "ทิศทางหลักสำหรับข้อความ",
		"queryStudio": "เคียวรีสตูดิโอ",
		"metricsManager": "ผู้จัดการเมทริกซ์",
		"password": "รหัสผ่าน",
		"invalidEmail": "ป้อนอีเมลแอดเดรสที่ถูกต้อง",
		"credentialCreateSuccess": "คุณสร้างหนังสือรับรองของคุณเสร็จเรียบร้อยแล้ว",
		"settings": "การตั้งค่า",
		"restrictedFormatSelected": "คุณไม่สามารถรันรายงานในรูปแบบนี้ แต่คุณสามารถเข้าถึงรายงานที่คุณบันทึกในรูปแบบนี้",
		"usageDataDeletionConfirmation": "การลบข้อมูลผู้ใช้จะรีเซ็ตการเรียนรู้ต่างๆ ของ AI  คุณแน่ใจว่าต้องการลบข้อมูลผู้ใช้หรือไม่?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "ดูรายละเอียด",
		"deleteUsageData": "ลบข้อมูลผู้ใช้:",
		"showPassword": "แสดงรหัสผ่าน",
		"AILearning_config_title": "การเรียนรู้ของ AI",
		"myPreferencesSlideoutLabel": "โปรไฟล์และการตั้งค่า",
		"passWordChangeSuccess": "คุณเปลี่ยนรหัสผ่านของคุณเสร็จเรียบร้อยแล้ว",
		"logging_level": "ระดับการล็อก:",
		"analysisStudio": "สตูดิโอการวิเคราะห์",
		"communityErrorMessage": "ลองอีกครั้ง  หากยังมีปัญหาอยู่ โปรดติดต่อผู้ดูแลระบบของคุณ",
		"cancel": "ยกเลิก",
		"shareSetError": "แอ็คชันนี้ไม่สามารถดำเนินการก่อนที่จะปิดและเปิดมุมมองนี้ใหม่",
		"passwordNotMatch": "รหัสผ่านไม่ตรงกัน",
		"xml": "XML",
		"xmlRestricted": "XML (จำกัด)",
		"openMenu": "เปิดเมนู",
		"closeMenu": 'ปิดเมนูu'
});